import axios from 'axios';
import { SecurityError } from '../../auth/merchantSecurity';
import { validWalletMoney } from './fastWalletTransfer';

export function parseTransferPolicy(response) {
    const p = response?.data;
    if (response?.code !== 1000) throw new SecurityError(response?.msg || '출금 정책을 조회하지 못했습니다.', response?.code);
    if (p?.supported === false && p.flow === 'LEGACY') return p;
    if (p?.supported !== true || p.flow !== 'REGISTERED_ACCOUNT_V2' || p.contract_version !== 2
        || typeof p.accepting_requests !== 'boolean' || typeof p.pin_required !== 'boolean'
        || typeof p.registration_required !== 'boolean'
        // PIN OFF may intentionally omit registration state using null.
        || (typeof p.pin_registered !== 'boolean' && !(p.pin_required === false && p.pin_registered === null))
        || (p.pin_required === false && p.registration_required !== false)
        || typeof p.csrf_token !== 'string' || !p.csrf_token.trim()
        || typeof p.policy_version !== 'string' || !p.policy_version
        || typeof p.account_policy_version !== 'string' || !p.account_policy_version
        || (p.pin_required && p.pin_registered === p.registration_required)) {
        throw new Error('지원하지 않는 출금 정책입니다. 다시 확인해주세요.');
    }
    return p;
}
export function sameTransferPolicy(a, b) {
    return ['supported', 'flow', 'contract_version', 'accepting_requests', 'pin_required', 'pin_registered',
        'registration_required', 'policy_version', 'account_policy_version'].every(key => a?.[key] === b?.[key]);
}
export function registeredWithdrawalBody(amount, requestId, authorization) {
    if (!validWalletMoney(amount) || Number(amount) <= 0 || typeof requestId !== 'string' || !requestId) throw new Error('송금 요청 정보가 올바르지 않습니다.');
    return { amount: Number(amount), request_id: requestId, ...(authorization ? { authorization } : {}) };
}
export function createRegisteredWalletClient(api = process.env.REACT_APP_API) {
    let csrf = null;
    const get = async (path, params) => (await axios.get(`${api}/api/${path}`, { withCredentials: true, timeout: 15000, params })).data;
    const post = async (path, data) => {
        if (!csrf) throw new Error('출금 정책을 다시 확인해주세요.');
        try {
            return (await axios.post(`${api}/api/${path}`, data, { withCredentials: true, timeout: 15000,
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf } })).data;
        } catch (error) {
            if (error.response?.data) return error.response.data;
            // Never expose axios config containing PIN/proof data.
            throw new Error('서버 응답을 확인하지 못했습니다.');
        }
    };
    return {
        async policy() { csrf = null; const p = parseTransferPolicy(await get('user-wallet/transfer-policy')); csrf = p.csrf_token || null; return p; },
        async funds() {
            const r = await get('user-wallet/balance');
            if (r?.code !== 1000 || !validWalletMoney(r.data?.wallet?.available_balance) || !validWalletMoney(r.data?.withdrawal_fee)) throw new Error('잔액과 수수료를 확인하지 못했습니다.');
            const w = r.data.wallet;
            return { available: Number(w.available_balance), fee: Number(r.data.withdrawal_fee), bank: w.bank_cd, account: w.accnt_no, bankName: w.bank_nm, accountName: w.accnt_nm };
        },
        query: params => get('user-wallet/withdrawals', params),
        withdraw: (amount, requestId, authorization) => post('user-wallet/withdraw', registeredWithdrawalBody(amount, requestId, authorization)),
        security: { async post(path, body) { const r = await post(`security${path}`, body); if (r?.code !== 1000) throw new SecurityError(r?.msg || 'PIN 인증 실패', r?.code); return r.data; } },
        clear() { csrf = null; },
    };
}
